import { useEffect } from 'react';

import { useFloatingButtonStore } from '../../store/floatingButtonStore';
import { FloatingButtonType } from '../../type';
import {
  useKeyEscClose,
  usePopstateCloseModal,
  usePreventBodyScroll,
} from '../../utils/hook/hook';

export interface GlobalModalProps {
  modalContent: React.ReactNode;
  modalContentStyle?: React.CSSProperties;
  onClose?: () => void;
  bgColor?: string;
  preventBackgroundClick?: boolean;
}
const GlobalModal = ({
  modalContent,
  modalContentStyle = {},
  bgColor,
  onClose = () => {},
  preventBackgroundClick = false,
}: GlobalModalProps) => {
  const setFloatingButton = useFloatingButtonStore.use.setFloatingButton();

  usePreventBodyScroll();
  useKeyEscClose(onClose);
  usePopstateCloseModal(onClose);

  useEffect(() => {
    setFloatingButton(FloatingButtonType.NULL);
  }, [setFloatingButton]);

  return (
    <div className="fixed inset-0 overflow-y-scroll" style={{ zIndex: 5000 }}>
      <div
        onClick={preventBackgroundClick ? () => {} : onClose}
        className="fixed inset-0 bg-littleblack"
        style={{ backgroundColor: bgColor }}
      />
      <div
        className="absolute"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          ...modalContentStyle,
        }}
      >
        {modalContent}
      </div>
    </div>
  );
};

export default GlobalModal;
